import {
  SEARCH_CODE_PORTAL,
  SEARCH_CODE_PORTAL_SUCCESS,
  SEARCH_CODE_PORTAL_FAIL,
  GET_SEARCH_RESULT,
  GET_SEARCH_RESULT_SUCCESS,
  GET_SEARCH_RESULT_FAIL,
  GET_CAPCHA,
  GET_CAPCHA_SUCCESS,
  GET_CAPCHA_FAIL,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAIL,
  RESET_TYPE_DOWNLOAD,
} from "./actionTypes";

const INIT_STATE = {
  errorSearch: {},
  dataVerity: {
    model: null,
  },
  dataSearch: {},
  statusFailSearch : false,
  errorDownload: false,
  errorSearchResult: false,
  loadingDownload: false,
  loadingResult: false,
  resultDownload: {},
};

const Portal = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_TYPE_DOWNLOAD:
      return {
        ...state,
        errorDownload: false,
        errorSearchResult: false,
        loading: false,
      };
    case GET_CAPCHA:
      return {
        ...state,
        loading: true,
      };
    case GET_CAPCHA_SUCCESS:
      return {
        ...state,
        loading: false,
        capcha: action.payload,
      };
    case GET_CAPCHA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SEARCH_CODE_PORTAL:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_CODE_PORTAL_SUCCESS:
      return {
        ...state,
        loading: false,
        dataVerity: action.payload,
        errorSearch: {},
      };
    case SEARCH_CODE_PORTAL_FAIL:
      return {
        ...state,
        loading: false,
        errorSearch: action.payload,
        statusFailSearch: true,
        dataVerity: null,
      };
    case GET_SEARCH_RESULT:
      return {
        ...state,
        loadingResult: true,
      };
    case GET_SEARCH_RESULT_SUCCESS:
      return {
        ...state,
        loadingResult: false,
        dataSearch: action.payload,
      };
    case GET_SEARCH_RESULT_FAIL:
      return {
        ...state,
        loadingResult: false,
        errorSearchResult: true,
      };
    case DOWNLOAD_FILE:
      return {
        ...state,
        loadingDownload: true,
      };
    case DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        errorDownload: false,
        loadingDownload: false,
        resultDownload: {
          data: action.payload,
          success: true,
        },
      };
    case DOWNLOAD_FILE_FAIL:
      return {
        ...state,
        loading: false,
        errorDownload: true,
        loadingDownload: false,
      };
    default:
      return state;
  }
};

export default Portal;
